/* eslint-disable react/no-unknown-property */
import React from 'react';
import { convertAltitudeToKm } from 'utils';

// 좌표 변환 유틸리티 함수들
const toCartesian = (lat: number, lon: number, height: number) => {
  const latRad = (lat * Math.PI) / 180;
  const lonRad = (lon * Math.PI) / 180;
  const earthRadius = 6371;
  const radius = earthRadius + height;

  const x = radius * Math.cos(latRad) * Math.sin(lonRad);
  const y = radius * Math.sin(latRad);
  const z = radius * Math.cos(latRad) * Math.cos(lonRad);

  return { x, y, z };
};

const scaling = (x: number, y: number, z: number) => {
  const earthRadius = 6371;
  const scaleFactor = 10 / earthRadius;
  return {
    x: x * scaleFactor,
    y: y * scaleFactor,
    z: z * scaleFactor,
  };
};

interface GroundStationMarkerProps {
  groundStation: any;
}

const GroundStationMarker = ({ groundStation }: GroundStationMarkerProps) => {
  const stationPosition = {
    longitude: groundStation.longitudeDegrees,
    latitude: groundStation.latitudeDegrees,
    height: convertAltitudeToKm(groundStation.altitudeMeters),
  };
  
  const coords = toCartesian(stationPosition.latitude, stationPosition.longitude, stationPosition.height);
  const scaled = scaling(coords.x, coords.y, coords.z);

  return (
    <mesh 
      key={groundStation.groundStationId || groundStation.id}
      position={[scaled.x, scaled.y, scaled.z]}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <coneGeometry args={[0.2, 0.3, 4]} />
      <meshBasicMaterial color="#ff0000" />
    </mesh>
  );
};

export default GroundStationMarker;
